module.exports = __webpack_public_path__ + "static/media/AddRequest.c51415d9.svg";